import { AssistentItem } from '../assistent_config';
import { IDs } from '../../../../helpers/IDs';
import { TriggerService } from '../../../../core/trigger/trigger_service';

export function getAssistentConfigEigeneRaeumlichkeiten(data: any, triggerService: TriggerService): AssistentItem {
    const modul: string = (data || {}).MODUL_SELECTED || null;
    const eingabe_raum = {
        gliederung: modul === 'cfm' ? '2.5.2' : '2.4.2',
        name: 'Eigene Räumlichkeiten',
        dataName: 'Eigene Räumlichleiten',
        description: 'Dies ist das Formular zur Eingabe der angemieteten Räumlichkeiten.',
        type: 'EntityForm',
        addLabel: 'Neue eigene Räumlichkeit erfassen',
        entity: IDs.ENT_EIGENE_RAEUMLICHKEITEN,
        style: { marginLeft: 18 },
        // configFlag: 'inputWasser',
        customOnSaveDone: (entity: string, dataItem: any) => {
            triggerService.fire('reload', IDs.ENT_EIGENE_RAEUMLICHKEITEN);
        }
    };
    return eingabe_raum;
}
